// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { AxiosError } from 'axios';
import { getExamReviewData, submitReview } from '../../apis/exam';

export function useExamData(id: number, token: string): any {
  const result = getExamReviewData(id, token)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      // onError && onError(message);
      return message;
    })
  return result;
}

export function useSubmitReview(id: number, reviewList: any, token: string, examId: string): any {
  const result = submitReview(id, reviewList, token, examId)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      // onError && onError(message);
      return message;
    })
  return result;
}
